
//draw header canvas
function drawflower(heroSrc, canvasH, canvasW, top){
    //homeCanvas

    let canvas = document.getElementById('homeCanvas');
    let ctx = document.getElementById('homeCanvas').getContext('2d');

    // let canvasH = 960;
    // let canvasW = canvasH * (1.23);

    //imageTop
    let section = document.createElement('img');

    section.onload = function () {
    ctx.save();
    ctx.fillStyle="#ffffff";
    ctx.beginPath();
    ctx.moveTo(927.9,531.2);
    ctx.bezierCurveTo(923.1,512.6,918.1999999999999,494.1,918.1999999999999,478.00000000000006);
    ctx.bezierCurveTo(918.1999999999999,460.30000000000007,922.9999999999999,441.70000000000005,927.0999999999999,421.50000000000006);
    ctx.bezierCurveTo(934.3999999999999,391.6000000000001,942.3999999999999,360.20000000000005,931.8999999999999,330.30000000000007);
    ctx.bezierCurveTo(922.1999999999998,300.4000000000001,897.1999999999998,280.30000000000007,872.1999999999998,260.1000000000001);
    ctx.bezierCurveTo(856.0999999999998,247.20000000000007,841.4999999999998,235.10000000000008,831.0999999999998,221.4000000000001);
    ctx.bezierCurveTo(820.5999999999998,207.7000000000001,813.3999999999997,189.9000000000001,806.0999999999998,172.2000000000001);
    ctx.bezierCurveTo(793.9999999999998,143.2000000000001,781.8999999999997,113.3000000000001,755.2999999999998,94.7000000000001);
    ctx.bezierCurveTo(730.3,77,698,75.4,666.5,73);
    ctx.bezierCurveTo(646.3,71.4,626.2,70.6,608.4,64.9);
    ctx.bezierCurveTo(590.6999999999999,59.300000000000004,573.6999999999999,48.800000000000004,556,38.300000000000004);
    ctx.bezierCurveTo(529.4,22.1,501.9,6,471.3,6);
    ctx.lineTo(471.3,6);
    ctx.bezierCurveTo(439,6,411.6,23.7,384.20000000000005,40.7);
    ctx.bezierCurveTo(367.30000000000007,51.2,351.1,61.7,334.20000000000005,66.5);
    ctx.bezierCurveTo(317.30000000000007,72.1,297.90000000000003,73.8,277.70000000000005,74.6);
    ctx.bezierCurveTo(246.20000000000005,77,213.20000000000005,79.39999999999999,188.10000000000005,98);
    ctx.bezierCurveTo(163.00000000000006,116.60000000000001,150.20000000000005,146.4,138.90000000000003,174.6);
    ctx.bezierCurveTo(130.80000000000004,193.2,123.60000000000004,210.89999999999998,113.90000000000003,225.39999999999998);
    ctx.bezierCurveTo(104.20000000000003,239.09999999999997,89.70000000000003,251.2,74.40000000000003,263.29999999999995);
    ctx.bezierCurveTo(50.20000000000003,283.49999999999994,24.400000000000034,304.4,14.700000000000031,335.9);
    ctx.bezierCurveTo(5.000000000000028,367.4,13.100000000000032,398,21.20000000000003,428.7);
    ctx.bezierCurveTo(27.70000000000003,448.09999999999997,32.50000000000003,465.8,32.50000000000003,482.8);
    ctx.bezierCurveTo(32.50000000000003,500.5,27.700000000000028,519.1,23.60000000000003,539.3);
    ctx.bezierCurveTo(16.30000000000003,569.1999999999999,8.30000000000003,600.5999999999999,18.80000000000003,630.5);
    ctx.bezierCurveTo(27.70000000000003,659.5,53.50000000000003,679.7,77.70000000000003,699.9);
    ctx.bezierCurveTo(93.80000000000004,712.8,108.40000000000003,724.9,118.80000000000004,738.6);
    ctx.bezierCurveTo(129.30000000000004,752.3000000000001,136.50000000000003,770.1,143.80000000000004,787.8000000000001);
    ctx.bezierCurveTo(155.90000000000003,816.8000000000001,168.00000000000003,846.7,194.60000000000002,865.3000000000001);
    ctx.bezierCurveTo(219.60000000000002,883.0000000000001,251.90000000000003,884.7,283.3,887.1);
    ctx.bezierCurveTo(303.5,888.7,323.6,889.5,341.40000000000003,895.2);
    ctx.bezierCurveTo(359.1,900.8000000000001,376.1,911.3000000000001,393.8,921.8000000000001);
    ctx.bezierCurveTo(420.40000000000003,937.9000000000001,447.90000000000003,954.1,478.5,954.1);
    ctx.lineTo(478.5,954.1);
    ctx.bezierCurveTo(510.8,954.1,538.2,936.4,565.6,919.4);
    ctx.bezierCurveTo(582.5,908.9,598.7,898.4,615.6,893.6);
    ctx.bezierCurveTo(632.5,888,651.9,886.3000000000001,672.1,885.5);
    ctx.bezierCurveTo(703.6,883.1,736.6,880.7,761.7,862.1);
    ctx.bezierCurveTo(786.7,843.5,799.6,813.7,810.9000000000001,785.5);
    ctx.bezierCurveTo(819.0000000000001,766.9,826.2,749.2,835.9000000000001,734.7);
    ctx.bezierCurveTo(845.6000000000001,721,860.1000000000001,708.9000000000001,875.4000000000001,696.8000000000001);
    ctx.bezierCurveTo(899.6000000000001,676.6,925.4000000000001,655.7,935.1000000000001,624.2);
    ctx.bezierCurveTo(944.9,593.4,936,561.9,927.9,531.2);
    ctx.fill();
    ctx.restore();

    ctx.clip();

    ctx.drawImage(section, 0, top, canvasH, canvasW);
    ctx.restore();

    
    }
    if(document.getElementsByClassName('top-image-header')[0].getElementsByClassName('sym-slides').length > 0){
        section.src = heroSrc;
        $('.top-image-header .sym-slides').on('beforeChange', function(event, slick, currentSlide, nextSlide){
            //console.log();
            section.src = document.getElementsByClassName('hero-img')[nextSlide].getElementsByTagName('img')[0].getAttribute('src');
           
          });
    } else {
        section.src = heroSrc;
    }
	
}